export default "__VITE_ASSET__Dh$AEbat__"